module.exports = __webpack_public_path__ + "static/img/位图.0bb684e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/位图.png
// module id = KMMc
// module chunks = 2